import { render, staticRenderFns } from "./EmailAddressDialog.vue?vue&type=template&id=9452987e"
import script from "./EmailAddressDialog.vue?vue&type=script&lang=js"
export * from "./EmailAddressDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailAddressDialog.vue?vue&type=style&index=0&id=9452987e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports